"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SelectCell = _interopRequireDefault(require("./SelectCell"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SelectWithCommentCell = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectWithCommentCell, _React$Component);
  var _super = _createSuper(SelectWithCommentCell);
  function SelectWithCommentCell(props) {
    var _this;
    _classCallCheck(this, SelectWithCommentCell);
    _this = _super.call(this, props);
    _this.updateValue = function (e, res) {
      var handleChange = _this.props.handleChange;
      var newE = {
        target: {
          name: e.target.name,
          value: e.target.value
        }
      };
      _this.setState({
        value: newE.target.value
      }, handleChange(newE, res));
    };
    _this.render = function () {
      var _this$props = _this.props,
        displayError = _this$props.displayError,
        name = _this$props.name,
        value = _this$props.value,
        showComment = _this$props.showComment,
        width = _this$props.width,
        id = _this$props.id,
        type = _this$props.type,
        options = _this$props.options,
        displayCommentButton = _this$props.displayCommentButton,
        data = _this$props.data,
        placeholder = _this$props.placeholder,
        handleBlur = _this$props.handleBlur;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !displayCommentButton ? /*#__PURE__*/_react.default.createElement(_SelectCell.default, {
        options: options,
        name: name,
        width: width,
        displayError: displayError,
        fluid: "true",
        placeholder: placeholder,
        value: value,
        handleChange: _this.updateValue,
        handleBlur: handleBlur
      }) : /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Cell, {
        className: "femaGoTableSelectCell",
        width: width
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
        className: displayError ? 'errorFieldBorder' : ''
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ui right icon input"
      }, /*#__PURE__*/_react.default.createElement("select", {
        id: id,
        name: name,
        onChange: _this.updateValue,
        onBlur: handleBlur,
        value: value,
        type: type
      }, /*#__PURE__*/_react.default.createElement("option", {
        defaultValue: true,
        disabled: true,
        selected: true
      }), options.map(function (option) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: option.key,
          value: option.value
        }, option.text);
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
        icon: true,
        title: 'View comment for ' + value,
        name: "other",
        className: "smallButton warningInputPrice leftMargin",
        color: "blue",
        onClick: function onClick() {
          return showComment(data, id);
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        className: "warningInputPrice",
        name: "pencil",
        title: "Other selected for BOC"
      })))))));
    };
    _this.state = {
      value: props.value
    };
    return _this;
  }
  return _createClass(SelectWithCommentCell);
}(_react.default.Component);
SelectWithCommentCell.propTypes = {
  /** For the question */
  options: _propTypes.default.array.isRequired,
  value: _propTypes.default.any,
  size: _propTypes.default.string,
  /* Error */
  displayError: _propTypes.default.bool,
  errorMessages: _propTypes.default.any,
  /** Functions */
  handleChange: _propTypes.default.func.isRequired,
  handleBlur: _propTypes.default.func
};
var _default = SelectWithCommentCell;
exports.default = _default;